
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7916_5)","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4.27 11.692H1.961a1.154 1.154 0 01-1.154-1.154V2.462a1.154 1.154 0 011.154-1.154h2.307M8.308 9.385L11.192 6.5 8.308 3.615M11.192 6.5H4.27"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7916_5"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    